
<template lang="html">
  <scroll
    class="server"
    :listenScroll="listenScroll"
    :probe-type="scrollProbeType"
    ref="server">
    <div class="ter">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in mainServer" :key="index">
          <img :src="item.bakImg" alt="" class="move">
          <div class="">
            <div class="">
              <div class="">
                <h1>{{item.title}}</h1>
                <p>{{item.intro}}</p>
              </div>
              <div class="qr-box" :class="{'lf': item.scanDetail}">
                <div class="" v-if="item.scanDetail">
                  <h2>{{item.scanDetail.wx}}</h2>
                  <p class="email">邮箱：{{item.scanDetail.email}}</p>
                  <!-- <p>福音热线：{{item.scanDetail.num}}</p> -->
                </div>
                <div class="img-box">
                  <img :src="item.qrImg" alt="" @click.stop="previewQr(item.qrImg)">
                </div>
              </div>
              <div class="scan-txt" v-if="item.scanTxt">
                <p>{{item.scanTxt}}</p>
              </div>
              <div class="btn-box" v-if="item.typeCt">
                <ul>
                  <li v-for="(inItem, inIndex) in item.typeCt" :key="inIndex">
                    <button type="button" name="button">{{inItem.name}}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>
      <div class="main">
        <div class="top">
          <h1>服务动态</h1>
        </div>
        <div class="main-content" v-for="(item, index) in serverActive" :key="index" :class="{'pb20': (serverActive.length - 1) === index}">
          <div class="content-imgbox">
            <img v-lazy="item.img" alt="" class="move">
          </div>
          <div class="detail">
            <div class="top-in">
              <h1>{{item.title}}</h1>
              <div class="more" v-show="item.more">
                更多
                <i class="icon iconfont icon-gengduo1"></i>
              </div>
            </div>
            <div class="">
              <ul>
                <li v-for="(inItem, inIndex) in item.content" :key="inIndex">
                  <p>{{inItem.item}}</p>
                  <span>{{inItem.date}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <m-footer></m-footer>
    </div>
  </scroll>
</template>

<script>
// import 'swiper/dist/css/swiper.css'
import 'common/ter/stylus/base.styl'
import Scroll from 'base/scroll/scroll'
import MFooter from 'components/ter/footer/footer'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import serverData from 'common/ter/js/server'
import {mapGetters, mapMutations} from 'vuex'
// import {navShowMixin} from 'common/js/mixin'
// console.log(serverData)
export default {
  // mixins: [navShowMixin],
  // methods: {
  //   handleNavShow (val) {
  //     let valTop = ''
  //     if (val) {
  //       valTop = '85px'
  //     } else {
  //       valTop = '50px'
  //     }
  //     this.$refs.server.$el.style.top = valTop
  //   }
  // },
  created () {
    this.scrollProbeType = 2
    this.mainServer = serverData.mainServer
    this.serverActive = serverData.serverActive
  },
  data () {
    return {
      serverActive: null,
      mainServer: null,
      listenScroll: true,
      swiperOption: {
        notNextTick: true, // 循环
        loop: true, // 设定初始化时slide的索引
        initialSlide: 0, // 自动播放
        autoplay: true,
        // autoplay: {
        //     delay: 3000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true,
        // },
        // 设置轮播
        // effect: 'flip',
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: 'horizontal',
        // 小手掌抓取滑动
        // grabCursor : true,
        // 滑动之后回调函数
        // on: {
        //   slideChangeTransitionEnd: function () {
        //     // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
        //   }
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // 分页器设置
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  methods: {
    // 二维码预览
    previewQr (url) {
      this.setImg(url)
      this.preview(true)
    },
    ...mapMutations({
      preview: 'SET_IS_SHOW',
      setImg: 'SET_IMG_URL'
    })
  },
  components: {
    swiper,
    swiperSlide,
    Scroll,
    MFooter
  },
  computed: {
    ...mapGetters(['isShow']),
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import "~common/ter/stylus/media"
.pb20
  padding-bottom: 20px !important
.swiper-slide
  &>img
    width: 100%
    set-height(300)
  &>div
    position: absolute
    left: 0
    right: 0
    top: 50%
    transform: translatey(-50%)
    text-align: center
    h1
      font-size: 18px
      color: #fff
    p
      font-size: 12px
      color: #fff
      margin: 6px 0 15px
    .qr-box
      width: 194px
      height: 65px
      display: flex
      justify-content: center
      align-items: center
      text-align: left
      margin: auto
      .img-box
        width: 60px
        height: 60px
        background-color: rgba(255, 255, 255, .3)
        padding: 4px
        img
          width: 52px
          height: 52px
      h2
        font-size: 10px
        color: #fff
        margin-bottom: 10px
      p
        font-size: 8px
        margin: 0
      &.lf
        justify-content: space-between
        border: 1px solid rgba(255,255,255,0.5)
        padding: 6px 6px 6px 10px
        .img-box
          width: 50px
          height: 50px
          padding: 0
          background-color: rgba(0, 0, 0, 0)
          img
            width: 50px
            height: 50px
    .btn-box
      margin-top: 30px
    .qr-ctn
      width: 192px
      height: 63px
      justify-content: space-between
      margin: auto
      margin-bottom: 13px
      padding: 4px
      background-color: rgba(255, 255, 255, .2)
      .img-box
        width: 55px
        height: 55px
        background-color: none
        padding: 0
        img
          width: 55px
          height: 55px
      .email
        margin: 10px 0 2px
    .scan-txt
      font-size: 10px
      color: #fff
    button
      width: 90px
      height: 35px
      border-radius: 35px
      overflow: hidden
      background-color: #fff
      color: #007CE5
      font-size: 12px
      cursor: pointer
.main
  width: 100%
  background-color: #F5F5F5
  .top
    position: relative
    padding: 20px 18px 10px
    background-color: #fff
    &:after
      content: ''
      width: 4px
      height: 10px
      position: absolute
      left: 10px
      top: 23px
      background-color: #007CE5
    h1
      font-size: 14px
      color: #007CE5
  .main-content
    display: flex
    position: relative
    margin-top: 40px
    padding-bottom: 10px
    background-color: #fff
    .content-imgbox
      flex: 0 0 170px
    img
      width: 170px
      height: 120px
    .detail
      width: calc(100% - 170px)
      ul
        margin-left: 10px
      li
        position: relative
        font-size: 10px
        line-height: 1
        padding: 5px 0
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        p
          width: 100%
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          margin-bottom: 5px
          padding-top: 5px
        span
          font-size: 9px
          color: #999
        &:after
          content: ''
          width: 100%
          height: 1px
          position: absolute
          left: 0
          bottom: 0
          background-color: #ECECEC
      h1
        font-size: 14px
        color: #333
        &>div
          font-size: 10px
      i
       margin-left: 5px
       font-size: 10px
    .top-in
      width: 100%
      position: absolute
      top: -36px
      left: 0
      right: 0
      display: flex
      justify-content: space-between
      align-items: center
      color: #333
      padding: 10px
      .more
        display: flex
        color: #007CE5
        align-items: center
</style>



// WEBPACK FOOTER //
// src/components/ter/server/server.vue